
import React, { useEffect, useState } from 'react'
import { Input, message, Space, Table, Tooltip } from 'antd'
import axios from 'axios'
import { useLocation } from 'react-router-dom';
import AdminProfile from './AdminProfile';
import NewTransactionTable from './NewTransactionTable';
import Model from '../Layout/Model';

import {
  MdInfoOutline,
} from "react-icons/md";
const { Search } = Input;


const BOT = (props) => {
  const [searchText, setSearchText] = useState('');
  const { userName, formSubmitted, FilterValue, filter, selectedapi } = props;
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [data, setData] = useState([]);
  const [dataDetails, setDataDetails] = useState([]);
  const [data1, setData1] = useState([]);
  const [statusFilterValue, setStatusFilterValue] = useState("TRADE");
  const [levelFilter, setLevelFilter] = useState(null);
  const [UsernameFilter, setUsernameFilter] = useState(null);
  const [ApiFilter, setApiFilter] = useState(selectedapi);
  const [dateFilter, setdateFilter] = useState(null);
  const [TransidFilter, setTransidFilter] = useState(null);
  const location = useLocation();
  const { profile } = AdminProfile()
  const [gatewayFilter, setGatewayFilter] = useState(null);
  const [assetsFilter, setAssetsFilter] = useState(null);
  const jwt = localStorage.getItem('jwt');

  const ViewBot = (statusFilterValue, usernameValue, form_by, datefilter, apifilter, transidValue) => {
    const jwt = localStorage.getItem('jwt');

    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,
      exchange_type: filter === "ALL" ? ["SPOT", "FUTURES"] : [filter],
      // api_name: selectedapi ? [selectedapi] : [],
      api_type:["LIVE"]

      // username: location.pathname === '/UpdateUser' ? [userName] : [userName],
      // by: location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' ? [profileAvatar] : ""

      // by: [profileAvatar, "User"]
    };
    if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
      postData.username = [userName];
    }

    // if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
    //   postData.api_name = [selectedapi];
    // }

    // if (apifilter !== null && apifilter.length > 0) {
    //   postData.api_name = [selectedapi];
    // }


    if (datefilter !== null && datefilter.length > 0) {
      postData.date = datefilter;
    }


    // if (location.pathname === '/dashboard/activeuser') {
    //     postData.pack = [FilterValue];
    // } else if (statusFilterValue !== null && statusFilterValue !== undefined) {
    //     postData.pack = [statusFilterValue];
    // }


    if (form_by !== null && form_by !== undefined) {
      postData.by = [form_by]
    }


    if (transidValue !== null && transidValue !== undefined) {
      postData.transid = [transidValue];
    }

    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_API + '/bot/view_bots',
      data: postData
    }).then(res => {
      if (res?.data?.Success === "No transactions yet!") {
        setData([]);
        // message.info("No transactions yet!");
      } else {
        setData(res?.data?.Success);
        // props.formSubmitted(data)
      }
    }).catch(err => {
      // message.error(err);
    });
  };

  const ViewTotalBot = (statusFilterValue, usernameValue, form_by, apifilter, datefilter, transidValue) => {
    const jwt = localStorage.getItem('jwt');

    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,
      exchange_type: filter === "ALL" ? ["SPOT", "FUTURES"] : [filter],
      // api_name: selectedapi ? [selectedapi] : [],
      api_type:["LIVE"]
    };

    if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
      postData.username = [userName];
    }

    // if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
    //   postData.api_name = [selectedapi];
    // }

    //  if (apifilter !== null && apifilter.length > 0) {
    //   postData.api_name = [selectedapi];
    // }

    if (datefilter !== null && datefilter.length > 0) {
      postData.date = datefilter;
    }

    // if (location.pathname === '/dashboard/activeuser') {
    //     postData.pack = [FilterValue];
    // } else if (statusFilterValue !== null && statusFilterValue !== undefined) {
    //     postData.pack = [statusFilterValue];
    // }

    if (form_by !== null && form_by !== undefined) {
      postData.by = [form_by]
    }


    if (transidValue !== null && transidValue !== undefined) {
      postData.transid = [transidValue];
    }

    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_API + '/bot/total_page_view_bots',
      data: postData
    }).then(res => {
      setTotalPages(res?.data?.Success);
    }).catch(err => {
      console.log(err);
    });
  };

  const ViewBotDetails = () => {

    const postData = {
      jwt: jwt,
      username: userName
    };

    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_API + '/bot/trade_details',
      data: postData
    }).then(res => {
      const data = res?.data?.Success;
      setDataDetails(data);
    }).catch(err => {
      message.error(err);
    });
  };

  // useEffect(()=>{
  //   ViewBotDetails();
  // },[userName])

  useEffect(() => {
    if (userName) {
      // These functions will be called whenever selectedapi changes
      ViewBotDetails();
      ViewTotalBot(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue, filter);
      ViewBot(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue, filter);
    }
    
  }, [ userName, page, size, statusFilterValue, formSubmitted, dateFilter, FilterValue, UsernameFilter, TransidFilter, gatewayFilter, filter, assetsFilter]);

  const [statusTPModal, setStatusTPModal] = useState(false)
  const [statusWalletModal, setStatusWalletModal] = useState(false)
  const [selectedData, setSelectedData] = useState()

  const [recordValue, setRecordValue] = useState("")
  const WalletPasswordUpdate = (value) => {
    setRecordValue(value)
    setStatusWalletModal(true)
  }
  const TransPasswordUpdate = (value) => {
    setRecordValue(value)
    setStatusTPModal(true)
  }

  const columns = [
    { title: "Datetime", dataIndex: "Created_At", key: "Created_At", className: "whitespace-nowrap " },
    ...(filter === "FUTURES" ? [
      { title: "Current Session Long", dataIndex: "Current_SessionL", key: "Current_SessionL", className: "whitespace-nowrap " },
      { title: "Current Session Short", dataIndex: "Current_SessionS", key: "Current_SessionS", className: "whitespace-nowrap " },
    ] : [
      { title: "Current Session", dataIndex: "Current_Session", key: "Current_Session", className: "whitespace-nowrap " },
    ]),
    { title: "Exchange", dataIndex: "Exchange", key: "Exchange", className: "whitespace-nowrap " },
    { title: "Type", dataIndex: "Type", key: "Type", className: "whitespace-nowrap " },
    { title: "Bot ID", dataIndex: "CopyTradeID", key: "CopyTradeID", className: "whitespace-nowrap " },
    { title: "API Name", dataIndex: "API_Name", key: "API_Name", className: "whitespace-nowrap " },
    // {
    //   title: "Key",
    //   dataIndex: "Key",
    //   key: "Key",
    //   className: "whitespace-nowrap ",
    //   render: (text) => (
    //     text ? (
    //       <Tooltip title={text}>
    //         {text.slice(0, 4) + "***" + text.slice(-6)}
    //       </Tooltip>
    //     ) : "--"
    //   )
    // },
    { title: "Bot Name", dataIndex: "BotName", key: "BotName", className: "whitespace-nowrap " },
    { title: "Symbol", dataIndex: "Symbol", key: "Symbol", className: "whitespace-nowrap " },
    { title: <Tooltip title="Investment Risk"><div>Invest (R)</div></Tooltip>, dataIndex: "Investment_Risk", key: "Investment_Risk", className: "whitespace-nowrap " },
    { title: "Invest", dataIndex: "InvestValue", key: "InvestValue", className: "whitespace-nowrap " },

    { title: <Tooltip title="Base Order Volume"><div>BOV</div></Tooltip>, dataIndex: "BaseOrderValue", key: "BaseOrderValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Volume Multiplier"><div>VM</div></Tooltip>, dataIndex: "VolumeMultiplierValue", key: "VolumeMultiplierValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Loss Percent"><div>Loss (%)</div></Tooltip>, dataIndex: "LossPercentValue", key: "LossPercentValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Take Profit Percent"><div>TP (%)</div></Tooltip>, dataIndex: "TakeProfitPercentValue", key: "TakeProfitPercentValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Loss Multiplier"><div>LM</div></Tooltip>, dataIndex: "LossMultiplierValue", key: "LossMultiplierValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Order Count"><div>OC</div></Tooltip>, dataIndex: "OrderCountValue", key: "OrderCountValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Current Order Count"><div>COC</div></Tooltip>, dataIndex: "CurrentOrderCountValue", key: "CurrentOrderCountValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Current Volume Multiplier"><div>CVM</div></Tooltip>, dataIndex: "CurrentVolumeMultiplierValue", key: "CurrentVolumeMultiplierValue", className: "whitespace-nowrap " },
    { title: <Tooltip title="Current Loss Multiplier"><div>CLM</div></Tooltip>, dataIndex: "CurrentLossMultiplierValue", key: "CurrentLossMultiplierValue", className: "whitespace-nowrap " },
    { title: "Drawdown", dataIndex: "Drawdown", key: "Drawdown", className: "whitespace-nowrap " },
    { title: <Tooltip title="Take Profit"><div>TP</div></Tooltip>, dataIndex: "Take_Profit", key: "Take_Profit", className: "whitespace-nowrap " },
    { title: "Balance", dataIndex: "BalanceValue", key: "BalanceValue", className: "whitespace-nowrap " },
    { title: "Hold", dataIndex: "HoldValue", key: "HoldValue", className: "whitespace-nowrap " },
    {
      title: "Stop Bot", dataIndex: "stop", key: "stop", className: "whitespace-nowrap ",
      render: (text, record) => {
        const isDisabled = record.Status === "STOP" || record.Status === "INACTIVE";
      
        return (
          <div className="flex items-center gap-3">
            <button
              disabled={isDisabled}
              onClick={() => {
                WalletPasswordUpdate(record.CopyTradeID);
              }}
              className={`text-black ${
                isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
              }`}
            >
              Click
            </button>
          </div>
        );
      }
    },
    {
      title: "Delete Bot", dataIndex: "delete", key: "delete", className: "whitespace-nowrap ",
      render: (text, record) => {
        const isDisabled = record.Status === "STOP" || record.Status === "INACTIVE";
      
        return (
          <div className="flex items-center gap-3">
            <button
              disabled={isDisabled}
              onClick={() => {
                TransPasswordUpdate(record.CopyTradeID);
              }}
              className={`text-black ${
                isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
              }`}
            >
              Click
            </button>
          </div>
        );
      }
    },
    { title: "Status", dataIndex: "Status", key: "Status", className: "whitespace-nowrap ",
      render: (text, record) => (
        <>
          <div className="justify-center flex items-center gap-2">
            <div>{text}</div>
            {record.Status === "STOP" ? (
              <Tooltip title={record.Reason}>
                {" "}
                <MdInfoOutline size={15} className="" />
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        </>
      ),
     },
  ];

  const getValueForExchangeType = (exchangeType, values) => {
    if (exchangeType === "FUTURES") {
      return values.reduce((acc, val) => acc + (val || 0), 0);
    }
    return values || "--";
  };

  const dataSource = data.map((item) => ({
    Bot_ID: item?.Bot_ID || "--",
    APIID: item?.APIID || "--",
    API_Name: item?.API_Name || "--",
    Key: item?.Key || "--",
    Project: item?.Project || "--",
    Secret: item?.Secret || "--",
    Passphrase: item?.Passphrase || "--",
    Exchange_Type: item?.Exchange_Type || "--",
    Exchange: item?.Exchange || "--",
    Type: item?.Type || "--",
    Reason: item?.Reason || "",
    CopyTradeID: item?.CopyTradeID || "--",
    VarBotID: item?.VarBotID || "--",
    BotName: item?.BotName || "--",
    Symbol: item?.Symbol || "--",
    Investment_Risk: item?.Investment_Risk || "--",
    InvestValue: getValueForExchangeType(item?.Exchange_Type, [item?.InvestL, item?.InvestS, item?.Invest]),
    BaseOrderValue: getValueForExchangeType(item?.Exchange_Type, [item?.BaseOrderVolumeL, item?.BaseOrderVolumeS, item?.BaseOrderVolume]),
    BalanceValue: getValueForExchangeType(item?.Exchange_Type, [item?.BalanceL, item?.BalanceS, item?.Balance]),
    HoldValue: getValueForExchangeType(item?.Exchange_Type, [item?.HoldL, item?.HoldS, item?.Hold]),
    CurrentLossMultiplierValue: getValueForExchangeType(item?.Exchange_Type, [item?.CurrentLossMultiplierL, item?.CurrentLossMultiplierS, item?.CurrentLossMultiplier]),
    CurrentVolumeMultiplierValue: getValueForExchangeType(item?.Exchange_Type, [item?.CurrentVolumeMultiplierL, item?.CurrentVolumeMultiplierS, item?.CurrentVolumeMultiplier]),
    CurrentOrderCountValue: getValueForExchangeType(item?.Exchange_Type, [item?.CurrentOrderCountL, item?.CurrentOrderCountS, item?.CurrentOrderCount]),
    OrderCountValue: getValueForExchangeType(item?.Exchange_Type, [item?.OrderCountL, item?.OrderCountS, item?.OrderCount]),
    LossPercentValue: getValueForExchangeType(item?.Exchange_Type, [item?.LossPercentL, item?.LossPercentS, item?.LossPercent]),
    TakeProfitPercentValue: getValueForExchangeType(item?.Exchange_Type, [item?.TakeProfitPercentL, item?.TakeProfitPercentS, item?.TakeProfitPercent]),
    VolumeMultiplierValue: getValueForExchangeType(item?.Exchange_Type, [item?.VolumeMultiplierL, item?.VolumeMultiplierS, item?.VolumeMultiplier]),
    LossMultiplierValue: getValueForExchangeType(item?.Exchange_Type, [item?.LossMultiplierL, item?.LossMultiplierS, item?.LossMultiplier]),
    LossMultiplierValue: getValueForExchangeType(item?.Exchange_Type, [item?.LossMultiplierL, item?.LossMultiplierS, item?.LossMultiplier]),
    Current_Session: item?.Current_Session || "--",
    Current_SessionL: item?.Current_SessionL || "--",
    Current_SessionS: item?.Current_SessionS || "--",
    OrderTypeOpen: item?.OrderTypeOpen || "--",
    OrderTypeClose: item?.OrderTypeClose || "--",
    Drawdown: item?.Drawdown || "--",
    Take_Profit: item?.Take_Profit || "--",
    Status: item?.Status || "--",
    Total_Investment: item?.Total_Investment || "--",
    Initial_Balance: item?.Initial_Balance || "--",
    TotalQuantity: item?.TotalQuantity || "--",
    AvgBuyPrice: item?.AvgBuyPrice || "--",
    Brokerage: item?.Brokerage || "--",
    TotalBrokerage: item?.TotalBrokerage || "--",
    BuyPrice: item?.BuyPrice || "--",
    SellPrice: item?.SellPrice || "--",
    HoldingPeriod: item?.HoldingPeriod || "--",
    Created_At: item?.Created_At
  }));

  const handleStatusCancelWallet = () => {
    setStatusWalletModal(false);
};

const handleStatusCancelTP = () => {
    setStatusTPModal(false);
};

  const handleTPStatus = (values) => {
    const jwt = localStorage.getItem('jwt')
    const postData = {
        jwt: jwt,
        username: userName,
        bot_id: recordValue,
        reason: values?.fundComment
    }

    const response = axios({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        url: process.env.REACT_APP_API + "/bot/delete_bot",
        data: postData
    }).then(response => {
        const responseData = response?.data
        if (responseData?.Success) {
            message.success(responseData?.Success)
            setStatusTPModal(false)
            ViewTotalBot(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue, filter, selectedapi);
            ViewBot(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue, filter, selectedapi);
        } else {
            message.error(responseData?.Success)
        }
    }).catch(err => {
        message.error(err?.response?.data?.Error)
    })
}

  const handleWalletStatus = (values) => {
    const jwt = localStorage.getItem('jwt')
    const postData = {
      jwt: jwt,
      username: userName,
        bot_id: recordValue,
        reason: values?.fundComment
    }

    const response = axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_API + "/bot/stop_bot",
      data: postData
    }).then(response => {
      const responseData = response?.data
      if (responseData?.Success) {
        message.success(responseData?.Success)
        setStatusWalletModal(false)
        ViewTotalBot(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue, filter, selectedapi);
        ViewBot(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue, filter, selectedapi);
      } else {
        message.error(responseData?.Success)
      }
    }).catch(err => {
      message.error(err?.response?.data?.Error)
    })
  }


  const handleSearch = (value) => {
    setSearchText(value);
  };

  const prepareDataForCSV = () => {
    const csvData = Array.isArray(data) ? data.map((item, index) => ({
      Serial: index + 1,
      Bot_ID: item?.Bot_ID,
      APIID: item?.APIID,
      API_Name: item?.API_Name,
      Key: item?.Key,
      Project: item?.Project,
      Secret: item?.Secret,
      Passphrase: item?.Passphrase,
      Exchange_Type: item?.Exchange_Type,
      Exchange: item?.Exchange,
      Type: item?.Type,
      Username: item?.Username,
      CopyTradeID: item?.CopyTradeID,
      VarBotID: item?.VarBotID,
      BotName: item?.BotName,
      Symbol: item?.Symbol,
      Investment_Risk: item?.Investment_Risk,

      Invest: item?.Exchange_Type === "FUTURES" ? `${item.InvestL || "--"} + ${item.InvestS || "--"}` : item?.Invest || "--",
      Current_Session: item?.Current_Session,
      BaseOrderVolume: item?.BaseOrderVolume,
      VolumeMultiplier: item?.VolumeMultiplier,
      LossPercent: item?.LossPercent,
      TakeProfitPercent: item?.TakeProfitPercent,
      LossMultiplier: item?.LossMultiplier,
      OrderCount: item?.OrderCount,
      OrderTypeOpen: item?.OrderTypeOpen,
      OrderTypeClose: item?.OrderTypeClose,
      CurrentOrderCount: item?.CurrentOrderCount,
      CurrentVolumeMultiplier: item?.CurrentVolumeMultiplier,
      CurrentLossMultiplier: item?.CurrentLossMultiplier,
      Drawdown: item?.Drawdown,
      Take_Profit: item?.Take_Profit,
      Status: item?.Status,
      Total_Investment: item?.Total_Investment,
      Balance: item?.Balance,
      Initial_Balance: item?.Initial_Balance,
      TotalQuantity: item?.TotalQuantity,
      AvgBuyPrice: item?.AvgBuyPrice,
      Brokerage: item?.Brokerage,
      TotalBrokerage: item?.TotalBrokerage,
      Hold: item?.Hold,
      BuyPrice: item?.BuyPrice,
      SellPrice: item?.SellPrice,
      HoldingPeriod: item?.HoldingPeriod,
      Created_At: item?.Created_At
    })) : [];

    return csvData;
  };

  const handleLevelFilter = (value) => {
    setLevelFilter(value);
  };

  const renderBotDetails = (data) => {
    if (!data) return null;

    return (
      <div>
        <table className="table-auto w-full border-collapse rounded-lg border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border text-sm border-gray-300 px-2 py-1">Type</th>
              <th className="border border-gray-300 text-sm px-2 py-1">Total Bots</th>
              <th className="border border-gray-300 text-sm px-2 py-1">Active Bots</th>
              <th className="border border-gray-300 text-sm px-2 py-1">Stopped Bots</th>
              <th className="border border-gray-300 text-sm px-2 py-1">Deleted Bots</th>
              <th className="border border-gray-300 text-sm px-2 py-1">Total Fund</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 text-xs px-2 font-semibold py-1 text-center">PAPER</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_PAPER}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_Active_PAPER}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_Stopped_PAPER}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_Deleted_PAPER}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Fund_Allotted_PAPER}</td>
            </tr>
            <tr>
              <td className="border border-gray-300 text-xs px-2 py-1 font-semibold text-center">LIVE</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_LIVE}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_Active_LIVE}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_Stopped_LIVE}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Bots_Deleted_LIVE}</td>
              <td className="border border-gray-300 text-xs px-2 py-1 text-center">{data.Total_Fund_Allotted_LIVE}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const usernameFormat = selectedData?.Username || '';

  return (
    <>
      <div className='mt-5'>
        {!selectedapi && (
          <div>
            {renderBotDetails(dataDetails?.[0])} 
          </div>
        )}

        <NewTransactionTable data={data} handleSearch={handleSearch} prepareDataForCSV={prepareDataForCSV} onSearch={handleSearch} setData={setData} onLevelChange={handleLevelFilter} columns={columns} dataSource={dataSource} totalPages={totalPages} page={page} size={size} setPage={setPage} setSize={setSize} />
      </div>

      <Model
        title={<div className='flex justify-between mr-5 items-center'>
          <p>Stop Bot</p>
          <Tooltip title={usernameFormat} className='cursor-pointer'>
            <div>Bot ID: <span className='font-light'>{recordValue}</span></div>
          </Tooltip>
        </div>}
        open={statusWalletModal}
        onCancel={handleStatusCancelWallet}
        onFinish={handleWalletStatus}
      
        label1="Reason"
        name1="fundComment"
        placeholder1="Enter Reason"
        isRequired1={true}
      />
      <Model
        title={<div className='flex justify-between mr-5 items-center'>
          <p>Delete Bot</p>
          <Tooltip title={usernameFormat} className='cursor-pointer'>
            <div>Bot ID: <span className='font-light'>{recordValue}</span></div>
          </Tooltip>
        </div>}
        open={statusTPModal}
        onCancel={handleStatusCancelTP}
        onFinish={handleTPStatus}
      
        label1="Reason"
        name1="fundComment"
        placeholder1="Enter Reason"
        isRequired1={true}
      />
    </>
  )
}

export default BOT
